import { OreHeading, OreInput, OreStack, OreText } from '@edenredespana/oreneta'
import { useFormContext } from 'react-hook-form'
import { useTranslation } from 'react-i18next'

import { contractTranslation } from '@/Contract/ui/contractTranslation'
import { ContractForm } from '@/Contract/ui/hooks'
import { handleErrors } from '@/Shared/ui/form'

export const ContractBillingDataFormCommon = (): JSX.Element => {
  const { t } = useTranslation()
  const { register, formState } = useFormContext<ContractForm>()
  const { errors } = handleErrors(formState)

  return (
    <OreStack placeContent="stretch" space="large">
      <OreHeading as="h2" size="headline-md">
        {t(contractTranslation.billingData.form.data.title)}
      </OreHeading>

      <OreStack direction="row" space="2xsmall">
        <OreText>{t(contractTranslation.billingData.form.data.description)}</OreText>
        <OreText>
          <a
            href={`mailto: ${import.meta.env.VITE_CONTACT_EMAIL}?subject=${t(contractTranslation.billingData.form.data.subject)}`}
          >
            {import.meta.env.VITE_CONTACT_EMAIL}
          </a>
        </OreText>
      </OreStack>
      <OreStack direction="row" space="large" placeContent="stretch">
        <OreInput
          {...register('merchantName')}
          {...errors('merchantName')}
          id="name"
          label={t(contractTranslation.billingData.form.data.name.label)}
          disabled
        />
      </OreStack>
      <OreStack direction="row" space="large" placeContent="stretch" sameSize>
        <OreInput
          {...register('afiliateCode')}
          {...errors('afiliateCode')}
          id="afiliateCode"
          label={t(contractTranslation.billingData.form.data.afiliateCode.label)}
          disabled
        />
        <OreInput
          {...register('cif')}
          {...errors('cif')}
          id="cif"
          label={t(contractTranslation.billingData.form.data.cif.label)}
          disabled
        />
      </OreStack>
    </OreStack>
  )
}
